// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/bisystem/canvas/main/cells/cell/original.data/original.data.scss
// module id = 4903
// module chunks = 50